import React, { lazy, Suspense } from 'react';
import { render } from "react-dom";

const Vehicles = lazy(() => import(/* webpackChunkName: "Vehicles" */ './components/Vehicles'));

const vehicles = Array.from(document.querySelectorAll(".extranet-vehicles"));
if (vehicles != null) {
    vehicles.forEach(vehicle => {
        const vehiclesData =
            typeof vehicle.dataset.vehicles !== "undefined" ? JSON.parse(vehicle.dataset.vehicles) : [];

        const workshopHost =
            typeof vehicle.dataset.workshopHost !== "undefined" ? vehicle.dataset.workshopHost : "";

        const workshopLicenseplateParam =
            typeof vehicle.dataset.workshopLicenseplateParam !== "undefined" ? vehicle.dataset.workshopLicenseplateParam : "";

        const workshopMileageParam =
            typeof vehicle.dataset.workshopMileageParam !== "undefined" ? vehicle.dataset.workshopMileageParam : "";

        render(
            <Suspense fallback={<></>}>
                <Vehicles vehiclesData={vehiclesData} workshopHost={workshopHost} workshopLicenseplateParam={workshopLicenseplateParam} workshopMileageParam={workshopMileageParam} />
            </Suspense>,
            vehicle
        );
    });
}
